<template>
    <div ref="container" style="width: max-content; height: max-content; min-width: 43px; height: 58px; background: gray">
        <canvas ref="canvas" :style="{'width': width + 'px'}" :width="dataLength" height="58"></canvas>
    </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
    props: {
        data: {
            type: Object
        },
        dataLength: {
            type: Number,
            default: 43
        },
        width: {
            type: Number,
            default: 43
        },
        reverse: {
            type: Boolean,
            default: true
        }
    },
    mounted(){
        const self = this
        self.draw(self.$refs.canvas, this.data)
        watch(() => this.data, (newValue) => {
            self.draw(self.$refs.canvas, newValue)
        },{deep:true});
    },
    methods: {
        draw(canvas, data){
            if(!data){
                return
            }

            const ctx = canvas.getContext('2d', { willReadFrequently: true })
            const W = canvas.width;
            const H = canvas.height;
            const barSize = 1;

            /* ctx.fillStyle = '#f5e9ff'
            ctx.strokeStyle = '#8a66c7' */
            ctx.fillStyle = '#000000'
            ctx.strokeStyle = '#F5E9FF'
            /* ctx.globalCompositeOperation = 'lighter'; */
            // #f5e9ff
            ctx && ctx.clearRect(0, 0, W, H)
            ctx.fillRect(0, 0, W, H)

            if (this.reverse) {
                for (let i = 0; i < this.dataLength; i++) {
                    const max = data[data.length - 1 - i] / 255
                    ctx.lineWidth = barSize
                    ctx.beginPath();
                    ctx.moveTo(W - i, H) 
                    ctx.lineTo(W - i, H * (1 - max))
                    ctx.stroke()
                }
            } else {
                for (let i = 0; i < this.dataLength; i++) {
                    const max = data[i] / 255
                    ctx.lineWidth = barSize
                    ctx.beginPath();
                    ctx.moveTo(i, H) 
                    ctx.lineTo(i, H * (1 - max))
                    ctx.stroke()
                }
            }
        }
    },
};
</script>

<style scoped>
canvas {
    height: 58px; 
    min-height: 58px; 
    max-height: 58px; 
    /* border: 1px solid purple */
}
</style>